module.exports = __webpack_public_path__ + "static/media/1.1aaa7fe6.png";